function resolveStyle(style, state) {
  return typeof style === "function" ? style(state) : style;
}
export {
  resolveStyle
};
//# sourceMappingURL=resolveStyle.js.map
